var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('contestJudgesController', ['$scope', 'randomService', 'homeService', 'contestJudgesService',
    function ($scope, randomService, homeService, contestJudgesService ) {

        //#region Judges Info

        $scope.getContestJudges = function(){
            contestJudgesService.getContestJudges().then(
                function(response){
                    if(response && response.data){
                        $scope.judgesInfo = response.data;

                        $scope.judgesInfo.forEach(function(judge){
                            if(judge.name && judge.name.length > 0){
                                judge.firstName = judge.name.split(/(\s+)/)[0];
                            }
                        });
                    }
                }
            )
        }

        //#endregion

        $scope.getRecentEmbroideryProjects = function (count) {
            homeService.getEmbroideryProjects(count).then(function (response) {
                if (response && response.data) {
                    $scope.homePageProjects =
                        randomService.getRandomItemsfromListArray(
                            response.data, 4
                        );
                } else {
                    //HIDE THE PROJECTS ROW!!
                }
            });
        };

        $scope.initialize = function(){
            $scope.navOptions = [
                {
                    icon: "fa fa-share",
                    title: "Contests",
                    href: "/learning-center/contest"
                },
                {
                    icon: "fas fa-cloud-upload-alt",
                    title: "Judges",
                    href: "/learning-center/contest/judges"
                },
                {
                    icon: "far fa-check-circle",
                    title: "Winners",
                    href: "/learning-center/contest/past-winners"
                },
                {
                    icon: "far fa-envelope",
                    title: "Tips & Tricks",
                    href: "/learning-center/contest/tips-and-tricks"
                }
            ];
            $scope.getRecentEmbroideryProjects(15);
            $scope.getContestJudges();
        }
    }
]);
